/* unplugin-vue-components disabled */import { render } from "./Alone.vue?vue&type=template&id=1a5005dd&ts=true"
import script from "./Alone.vue?vue&type=script&lang=ts"
export * from "./Alone.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/alone/Alone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a5005dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a5005dd', __exports__)) {
    console.log('reload')
    api.reload('1a5005dd', __exports__)
  }
  
  module.hot.accept("./Alone.vue?vue&type=template&id=1a5005dd&ts=true", () => {
    console.log('re-render')
    api.rerender('1a5005dd', render)
  })

}


export default __exports__